
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  data() {
    return {
      m_paymentColumns: [
        {
          name: 'id',
          columnProps: {
            label: '应付ID',
            prop: 'id',
            width: 100,
          },
        },
        {
          name: 'payType',
          columnProps: {
            label: '付款内容',
            prop: 'payType',

          },
        },
        {
          name: 'payDate',
          columnProps: {
            label: '应付日期',
            prop: 'payDate',

          },
        },
        {
          name: 'payAmount',
          columnProps: {
            label: '应付金额',
            prop: 'payAmount',
          },
          getText: ({ row }) => this.numberWithCommas(row.payAmount),
        },
        {
          name: 'paidAmount',
          columnProps: {
            label: '已付金额',
            prop: 'paidAmount',
          },
          getText: ({ row }) => this.numberWithCommas(row.paidAmount),
        },
        {
          name: 'remarks',
          columnProps: {
            label: '备注',
            prop: 'remarks',
          },
        },
        {
          name: 'payState',
          columnProps: {
            label: '付款状态',
            prop: 'payState',
          },
        },
        {
          name: 'completeTime',
          columnProps: {
            label: '付款完成时间',
            prop: 'completeTime',
          },
        },
        {
          name: 'changeState',
          columnProps: {
            label: '是否变更',
            prop: 'changeState',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const result = []
            // 线下付款
            const offlinePayment = {
              name: 'offlinePayment',
              label: '线下付款',
              action: () => this.offlinePayment(row),
            }
            if (row.payState === '未完成' && Number(row.paidAmount) <= Number(row.payAmount)) {
              result.push(offlinePayment)
            }
            return result
          },
        },
      ],
    }
  },
}
